import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/apiClient";

export default function ForgotPasswordPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6 py-12">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8 fade-up">
        <div className="mb-6">
          <div className="text-xs uppercase tracking-[0.25em] text-slate-500 mb-2 font-semibold">
            Password reset
          </div>
          <h2 className="font-display text-3xl font-black tracking-tighter">
            {done ? "Check your email." : "Forgot your password?"}
          </h2>
          <p className="text-sm text-slate-600 mt-2">
            {done
              ? "If an account exists for that email, we've sent a reset link. It expires in 60 minutes."
              : "Enter the email you sign in with and we'll send you a one-time link to set a new password."}
          </p>
        </div>

        {!done && (
          <form onSubmit={submit} data-testid="forgot-password-form">
            <div className="mb-4">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1 block">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="qb-input font-mono text-sm"
                data-testid="forgot-email-input"
                autoFocus
              />
            </div>

            {err && (
              <div className="border border-red-200 bg-red-50 text-red-700 text-sm px-3 py-2 mb-4 rounded-lg" data-testid="forgot-error">
                {err}
              </div>
            )}

            <button
              disabled={busy}
              type="submit"
              className="w-full h-11 bg-brand-blue text-white font-semibold uppercase tracking-wider text-sm hover:bg-brand-blue-dark disabled:opacity-60 rounded-full transition-colors"
              data-testid="forgot-submit-button"
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <button
          type="button"
          onClick={() => nav("/login")}
          className="mt-4 text-xs uppercase tracking-wider text-slate-500 hover:text-brand-blue w-full font-semibold"
          data-testid="back-to-login-link"
        >
          ← Back to sign in
        </button>
      </div>
    </div>
  );
}
